/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/news.scss';

const propTypes = {
    items: PropTypes.array.isRequired, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const News = ({ items, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {items.map(item => (
                    <div className={styles.news}>
                        <h4 className={styles.title}>{item.title}</h4>
                        <div className={styles.text}>
                            <div className={styles.link}>
                                <a href={item.link.url} target="_blank" rel="noopener noreferrer">
                                    {item.link.text}
                                </a>
                            </div>

                            <div
                                className={styles.body}
                                dangerouslySetInnerHTML={{ __html: item.text }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

News.propTypes = propTypes;
News.defaultProps = defaultProps;

export default News;
